import {Header} from "antd/es/layout/layout";
import {useIsMobile} from "../../../_common/function";
import {Badge, Button, Col, Dropdown, Image, Menu, Popover, Row, Space} from "antd";
import {MenuOutlined} from "@ant-design/icons";
import React, {useEffect} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {
    globalBrandSettingState,
    globalColorThemeState,
    globalLanguageListState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState
} from "../../../_common/global_state";
import useShared from "../../../_common/_shared";
import useLayoutFunction from "../../function";
import {useVerification} from "../../../_common/_authorize";
import {useNavigate} from "react-router-dom";
import {getUserAnnouncementUnreadCount} from "../../../api/graphql/announcement";
import Announcement_5 from "../../../pages/announcement/view/layout_5";

const Header_5 = (props) => {
    const {
        onCollapsedChange,
        collapsed,
        setOpenQrModal,
    } = props;
    const navigate = useNavigate();
    const isMobile = useIsMobile(768);
    const {IconCommon, IconFlag} = useShared();
    const {changeLanguageHandler} = useLayoutFunction()
    const {handleTokenExpiration} = useVerification();

    const [colorState, setColorState] = useRecoilState(globalColorThemeState);
    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useRecoilState(globalUnreadAnnouncementCountState);
    const unreadPushNotificationCount = useRecoilValue(globalUnreadPushNotificationCountState);
    const languageListState = useRecoilValue(globalLanguageListState);
    const brandSettingState = useRecoilValue(globalBrandSettingState);

    const userId = localStorage.getItem("userid")

    const currentLanguageObj = languageListState?.find((lang) => lang?.code === localStorage.getItem("language"));

    const languageDropdown = (
        <Menu className={"language-dropdown-menu"} selectedKeys={[localStorage.getItem("language")]}>
            {languageListState?.map((lang) => (
                <Menu.Item
                    key={lang?.code}
                    value={lang?.code}
                    onClick={() => changeLanguageHandler(lang?.code)}
                >
                    <Space><IconFlag countryCode={lang?.countryCode} className={"w-6"}/> {lang?.nativeName}
                    </Space>
                </Menu.Item>
            ))}
        </Menu>
    );

    const preload = async () => {
        const unreadCount = await getUserAnnouncementUnreadCount(userId);
        setUnreadAnnouncementCount(unreadCount?.getUserAnnouncementByUserId?.unreadTotal);
    };

    useEffect(() => {
        preload();
    }, []);

    return (
        <Header id={"layout-header"}>
            <div className={"layout-header"}>
                {isMobile ? (
                    <Row justify={"start"}>
                        <Col span={10}>
                            <Button
                                type={"text"}
                                icon={<MenuOutlined/>}
                                onClick={() => onCollapsedChange(!collapsed)}
                            />
                        </Col>
                        <Col span={12}>
                            <Image
                                preview={false}
                                className={"header-logo"}
                                onClick={() => navigate("/dashboard")}
                                src={colorState === "dark" ? brandSettingState?.companyLogoInverse : brandSettingState?.companyLogo}
                            />
                        </Col>
                    </Row>
                ) : (
                    <Row justify={"space-between"}>
                        <div>
                            <Image
                                preview={false}
                                className={"header-logo"}
                                onClick={() => navigate("/dashboard")}
                                src={colorState === "dark" ? brandSettingState?.companyLogoInverse : brandSettingState?.companyLogo}
                            />
                        </div>
                        <div className={"layout-header-sub"}>
                            <Space>
                                <Dropdown
                                    overlay={languageDropdown}
                                    id={"language-select"}
                                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                    arrow
                                >
                                    <div
                                        className={"headerSpan"}
                                        onClick={(e) => e?.preventDefault()}
                                    >
                                        <IconFlag
                                            countryCode={currentLanguageObj?.countryCode}
                                            className={"w-6"}
                                        />
                                    </div>
                                </Dropdown>
                                <Popover
                                    trigger={["click"]}
                                    className={"cursor-pointer"}
                                    content={<Announcement_5 isHeader/>}
                                    id={"header-announcement"}
                                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                >
                                    <div
                                        className={"headerSpan"}
                                        onClick={(e) => e?.preventDefault()}
                                    >
                                        <Badge
                                            count={unreadAnnouncementCount + unreadPushNotificationCount}
                                            size={"small"}
                                            color={"red"}
                                        >
                                            <IconCommon
                                                iconName={"cm-notification-regular"}
                                                className={"w-6"}
                                            />
                                        </Badge>
                                    </div>
                                </Popover>
                                <div
                                    className={"cursor-pointer"}
                                    onClick={() => {
                                        if (colorState === "light") {
                                            setColorState("dark");
                                            localStorage.setItem("color", "dark");
                                        } else {
                                            setColorState("light");
                                            localStorage.setItem("color", "light");
                                        }
                                    }}
                                >
                                    {colorState !== "light" ? (
                                        <IconCommon iconName={"cm-lighttheme-regular"} className={"toggleIcon w-6"}/>
                                    ) : (
                                        <IconCommon iconName={"cm-darktheme-regular"} className={"toggleIcon w-6"}/>
                                    )}
                                </div>
                                <div>
                                    <IconCommon
                                        className={"cursor-pointer w-6"}
                                        iconName={"cm-qr-regular"}
                                        onClick={() => setOpenQrModal(true)}
                                    />
                                </div>
                                <div>
                                    <IconCommon
                                        className={"cursor-pointer w-6"}
                                        iconName={"cm-logout-regular"}
                                        onClick={() => handleTokenExpiration(true)}
                                    />
                                </div>
                            </Space>
                        </div>
                    </Row>
                )}
            </div>
        </Header>
    )
}

export default Header_5